/**
 * RESPONSIBILITY: the frame the new band templates share — a tinted or plain band, its column and its heading.
 *
 * The same `band`, `band-tint` and `ministry-section-band` classes the original band has,
 * so a new template sits in the page with the same spacing, width and rhythm. The heading
 * is here because every template may carry one and an empty one draws nothing.
 */
import type { ReactNode } from 'react';

export function BandFrame({ tinted, heading, children }: { tinted: boolean; heading?: string; children?: ReactNode }) {
  return (
    <section className={`${tinted ? 'band band-tint' : 'band'} ministry-section-band`}>
      <div className="wrap ministry-band-stack">
        {heading ? <h2>{heading}</h2> : null}
        {children}
      </div>
    </section>
  );
}
